import { type RootState } from '../../../lib/store';

export const selectProjectId = (state: RootState) => state.supervisorQueue?.projectId;
export const selectBatchId = (state: RootState) => state.supervisorQueue?.batchId;
export const selectProjectsListPage = (state: RootState) =>
  state.supervisorQueue?.projectsListPage ?? 0;
export const selectProjectsListPageSize = (state: RootState) =>
  state.supervisorQueue?.projectsListPageSize ?? 25;
